import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Option } from '@/common/types';
import { API_URL, ICovTableDto } from '@/dtos';

import formatTableOptionTitle from './formatTableOptionTitle';

export const QUERY_KEY = 'GET_COV_TABLES';

export const DEFAULT_COV_TABLE_KEY = 'default';

const DEFAULT_COV_TABLE_OPTION: Option = {
  key: DEFAULT_COV_TABLE_KEY,
  value: DEFAULT_COV_TABLE_KEY,
  title: 'Default',
};

const useCovTablesQuery = () => {
  const { data, isLoading } = useQuery([QUERY_KEY], () => api.get<ICovTableDto[]>(API_URL.COV_TABLES));

  const options = useMemo<Option[]>(() => {
    const list = data?.data || [];
    return [
      DEFAULT_COV_TABLE_OPTION,
      ...list.map((item) => ({
        key: toString(item.id),
        value: toString(item.id),
        title: formatTableOptionTitle(item.name, item.identifier),
      })),
    ];
  }, [data]);

  return {
    options,
    isLoading,
  };
};

export default useCovTablesQuery;
